module.exports = __webpack_public_path__ + "static/media/camera-home.bfaff97f.svg";